import { render, staticRenderFns } from "./Practice.vue?vue&type=template&id=6867ce68&scoped=true"
import script from "./Practice.vue?vue&type=script&lang=js"
export * from "./Practice.vue?vue&type=script&lang=js"
import style0 from "./Practice.vue?vue&type=style&index=0&id=6867ce68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867ce68",
  null
  
)

export default component.exports